module.exports = __webpack_public_path__ + "a52fdd979b0a47758ff7b9ed07e7b5ad.png";